import React from "react";
import { connect } from "react-redux";
import { Card, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import Search from "../../../assets/images/search.svg";
import { getreportcustomer, getReportOa, previewPo, shortStr, verifyDateFormat } from "../../../actions";
import "../../../assets/css/button.css";
import "../../../assets/css/popup.css";
import Re from "../../../assets/images/violet1.svg";
import Navbar from "../../../layouts/Navbar";
import Sidebar from "../../../layouts/Sidebar";
import Spinner from "../../../Components/loader";
import Pagination from "../../../Components/Pagination";
import parse from 'html-react-parser';
import { Link } from "react-router-dom";
import OaFilter from "./oaFilter";
import OaView from "./oaView";


const role = localStorage.getItem('userRole');
class OrderAcceptence extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            all_report_customer: [],
            allData: [],
            show: false,
            modal: false,
            data: [],
            previewQutationTxt: "",
            target: null,
            pageNo: 0,
            filterData: {
                searchKey: null,
                pageNo: 0,
                fromDate: null,
                toDate: null,
                sizeOfPage: 20,
                size: 10
            },
        };
        this.onChange = this.onChange.bind(this);
        this.getCustomerExe = this.getCustomerExe.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.resetHandler = this.resetHandler.bind(this);
        this.searchHandler = this.searchHandler.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(getReportOa(this.state.filterData));
    }
    handleClick = (event) => {
        if (!this.state.show) {
            this.setState({
                show: true,
                target: event.target
            })
        } else {
            this.setState({
                show: false,
            })
        }
    };
    handleSubmit(filterData) {
        let data = { ...this.state.filterData };
        data.fromDate = filterData.fromDate;
        data.toDate = filterData.toDate;
        this.setState({
            filterData: data
        })
        this.props.dispatch(getReportOa(data));
        this.setState({
            show: false,
        })
    }
    handleShow(row) {
        this.setState({
            modal: true,
            data: row
        })
        this.props.dispatch(previewPo(row.purchaseOrderId));
    }
    handleClose() {
        this.setState({
            modal: false,
            previewQutationTxt: undefined
        })
    }
    resetHandler() {
        let data = { ...this.state.filterData };
        data.fromDate = null;
        data.toDate = null;
        this.setState({
            filterData: data
        })
        this.props.dispatch(getReportOa(data));
        this.setState({
            show: false,
        })
    }
    getCustomerExe() {
        this.setState({
            show: false,
            filterData: []
        })
        this.props.dispatch(getreportcustomer(0));
    }
    componentDidUpdate(prevProps) {
        if (prevProps.allData !== this.props.allData) {
            this.setState({ allData: this.props.allData });
        }
    }
    searchHandler(e) {
        const { filterData } = this.state;
        let data = { ...filterData };
        data.searchKey = e.target.value;
        data.pageNo = 0;
        this.setState({
            filterData: data
        })
        this.props.dispatch(getReportOa(data));
    }
    onChange(pageNo) {
        let data = { ...this.state.filterData };
        data.pageNo = pageNo;
        this.setState({
            filterData: data
        })
        this.props.dispatch(getReportOa(data));
    }

    render() {
        const { allData, show, target, modal, previewQutationTxt } = this.state;

        let data = {
            totalElements: allData?.totalElements,
            totalPages: allData?.totalPages,
            offset: allData?.pageable?.offset,
            numberOfElements: allData?.numberOfElements,
            num: (allData?.number) + 1
        }

        return (
            <>
                <div>
                    <Navbar />
                    <div className="dashboard-page">
                        <div className="dashboard-sidebar">
                            <Sidebar />
                        </div>
                        <div className="dashboard-main">
                            <Card className="staff-page">
                                <div className="page-head-split">
                                    <div className="head-colums">
                                        <div className="head-part-tab">
                                            <img src={Re} alt="..." className="head-imgs" />
                                            <h5>Reports</h5>
                                        </div>
                                        <div className="tab-links">
                                            <Link to={"/" + role + "/sale_executive"} >Sales Executive</Link>
                                            <Link to={"/" + role + "/sale_executive/customer_executive"} >Customer</Link>
                                            <Link to={"/" + role + "/sale_executive/purchase_order"}>Purchase Order</Link>
                                            <Link to={"/" + role + "/sale_executive/oa"} className="active">OA</Link>
                                        </div>
                                        <div className="customer-search oa-search">
                                            <span><img src={Search} alt=".." className="search-img" /></span>
                                            <Form.Control type="search" placeholder="Search" onChange={this.searchHandler} className="main-search" />
                                        </div>
                                        <OaFilter
                                            onSubmit={this.handleSubmit}
                                            getCustomerExe={this.getCustomerExe}
                                            handleClick={this.handleClick}
                                            reset={this.resetHandler}
                                            show={show} target={target}
                                            str={this.props.str}
                                        />
                                    </div>
                                </div>
                                <div className="table-class">
                                    <table class="table table-borderless">
                                        <thead>
                                            <tr>
                                                <th>PO number</th>
                                                <th scope="col" >OA number</th>
                                                <th scope="col">Customer name</th>
                                                <th>Project name</th>
                                                <th>Product name</th>
                                                <th style={{ textAlign: "center" }}>Quantity</th>
                                                <th scope="col">OA date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {allData && allData?.content?.length > 0 ? (
                                                allData?.content?.map((one, i) => (
                                                    <tr key={i} onClick={() => this.handleShow(one)} style={{ cursor: "pointer" }}>
                                                        <td>{shortStr(one?.poNumber)}</td>
                                                        <td >{one?.oaNumber}</td>
                                                        <td>{one?.customerName || "-"}</td>
                                                        <td className="inward_project_size">
                                                            <OverlayTrigger overlay={<Tooltip id="tooltip-disabled"> {one?.projectName || "-"}</Tooltip>}>
                                                                <span className="d-inline-block">
                                                                    {one?.projectName || "-"}
                                                                </span>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td className="inward_new_size" >
                                                            <OverlayTrigger overlay={<Tooltip id="tooltip-disabled"> {parse(one?.productName || "-")}</Tooltip>}>
                                                                <span className="d-inline-block">
                                                                    {parse(one?.productName || "-")}
                                                                </span>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td style={{ textAlign: "center" }}>{one?.productQuantity}</td>
                                                        <td>{verifyDateFormat(one?.oaDate)}</td>
                                                    </tr>
                                                ))
                                            ) : !this.props.loading ?
                                                <h1 className="empty-data">No Records Found</h1> :
                                                <Spinner />
                                            }
                                        </tbody>
                                    </table>
                                </div> </Card>
                            <Pagination data={data} onChange={this.onChange} />
                        </div>
                    </div>
                    <OaView
                        show={modal}
                        onHide={this.handleClose}
                        data={this.state.data}
                        preview={previewQutationTxt}
                    />
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loading: state.oa.loading,
        page: state.oa.page,
        allData: state.oa.data,
    };
};
export default connect(mapStateToProps)(OrderAcceptence);

